import { SimpleQueryResponse } from './../../dtos/simpleQueryResponse';
import { ReferentielDTO } from './../../dtos/referentielDTO';
import { SocieteLinkedModel } from './../../models/societe-linked/societe-linked.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { APICONSTANTS } from 'src/app/shared/constants/api-constants';
import { GenericCrudService } from '../basic/generic.crud.service';
import { HostnameService } from '../basic/hostname.service';
import { BasicWithLibelleModel } from '../../models/basic/basicWithLibelle.model';

@Injectable()
export abstract class GenericLibelleService<T> extends GenericCrudService<T> {
  constructor(http: HttpClient,
              protected toastrService: ToastrService,
              protected route: string,
              protected hostnameService: HostnameService) {
              super(http, toastrService, route, hostnameService);
  }
  getAllFiltred(value: string, idSoc: number): Observable<T[]> {
    let param = new HttpParams();
    param = param.append('value', value);
    param = param.append('idSoc', idSoc ? idSoc.toString() : null);
    return this.http.get<BasicWithLibelleModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllFiltred', {params: param})
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  loadFromSimpleQueryAdmin(objet: ReferentielDTO): Observable<SimpleQueryResponse<T>> {
    return this.http.post<SimpleQueryResponse<T>>(APICONSTANTS.URLAPI.value + this.route + 'loadFromSimpleQueryAdmin', objet)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

  getWithCode(value: string): Observable<T> {
    let param = new HttpParams();
    param = param.append('value', value);
    return this.http.get<BasicWithLibelleModel>(APICONSTANTS.URLAPI.value + this.route + 'GetWithCode', {params: param})
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
  }

}
